export default __webpack_public_path__ + "static/media/pbs.cb8b4ef4.jpg";